export const LISTING_TYPE_URL_SEGMENT_MAP = {
  ALL: 'all',
  JOB: 'jobs',
  INTERNSHIP: 'internships',
  VOLOP: 'volops',
  ORG: 'organizations',
  GRAD_PROGRAM: 'grad-programs',
  USER: 'users',
};
